import { type AttributeValue } from "../../attribute/AttributeSet";
import { type UserAttributeSet, UserAttributeType } from "../UserAttributeSet";

import { attributeListToMap } from "@/utils/attributes";

export enum Seeking {
  ACTIVITY_PARTNERS = "activity_partners",
  CASUAL = "casual",
  CHAT = "chat",
  COFFEE_DATES = "coffee_dates",
  DATES = "dates",
  EVENTS = "events",
  FRIENDS = "friends",
  GYM_BUDDY = "gym_buddy",
  LGBTQ_COMMUNITY = "lgbtq_community",
  LONG_TERM = "long_term",
  NETWORKING = "networking",
  OPEN_RELATIONSHIP = "open_relationship",
  PLATONIC = "platonic",
  POLYAMOROUS = "polyamorous",
  RELATIONSHIP = "relationship",
  RIGHT_NOW = "right_now",
  ROMANCE = "romance",
  SUPPORT_GROUP = "support_group",
  TRAVEL_BUDDY = "travel_buddy",
  OTHER = "other",
  ASK_ME = "ask_me",
}

const SEEKING_ATTRIBUTE_OPTIONS: ReadonlyArray<AttributeValue> = [
  {
    id: Seeking.ACTIVITY_PARTNERS,
    label: "Activity Partners",
    iconLabel: "🤼",
  },
  { id: Seeking.CASUAL, label: "Casual", iconLabel: "🌴" },
  { id: Seeking.CHAT, label: "Chat", iconLabel: "💬" },
  { id: Seeking.COFFEE_DATES, label: "Coffee Dates", iconLabel: "☕" },
  { id: Seeking.DATES, label: "Dates", iconLabel: "📅" },
  { id: Seeking.EVENTS, label: "Events", iconLabel: "🎉" },
  { id: Seeking.FRIENDS, label: "Friends", iconLabel: "👥" },
  { id: Seeking.GYM_BUDDY, label: "Gym Buddy", iconLabel: "🏋️" },
  { id: Seeking.LGBTQ_COMMUNITY, label: "LGBTQ+ Community", iconLabel: "🏳️‍🌈" },
  { id: Seeking.LONG_TERM, label: "Long-term", iconLabel: "🔗" },
  { id: Seeking.NETWORKING, label: "Networking", iconLabel: "🌐" },
  {
    id: Seeking.OPEN_RELATIONSHIP,
    label: "Open Relationship",
    iconLabel: "🔓",
  },
  { id: Seeking.PLATONIC, label: "Platonic", iconLabel: "🤝" },
  { id: Seeking.POLYAMOROUS, label: "Polyamorous", iconLabel: "🔺" },
  { id: Seeking.RELATIONSHIP, label: "Relationship", iconLabel: "❤️" },
  { id: Seeking.RIGHT_NOW, label: "Right Now", iconLabel: "⚡" },
  { id: Seeking.ROMANCE, label: "Romance", iconLabel: "💖" },
  { id: Seeking.SUPPORT_GROUP, label: "Support Group", iconLabel: "🤲" },
  { id: Seeking.TRAVEL_BUDDY, label: "Travel Buddy", iconLabel: "✈️" },
  { id: Seeking.OTHER, label: "Other", iconLabel: "🔹" },
  { id: Seeking.ASK_ME, label: "Ask Me", iconLabel: "❓" },
];

export const UserSeekingAttributeSet: UserAttributeSet = {
  id: UserAttributeType.SEEKING,
  isMultiSelect: true,
  map: attributeListToMap(SEEKING_ATTRIBUTE_OPTIONS),
} as const;
